module.exports = __webpack_public_path__ + "images/lacrosse1-b0c6c51b921ec11de0d844f571706083.jpg";